import { Navigate } from 'react-router-dom';

/** Rota legada — redireciona para Clientes em modo grade. */
export function OverviewPage() {
  return <Navigate to="/clientes?view=grid" replace />;
}
